import styled from 'styled-components';

export const ContactItemStyles = styled.div<{ $truncate?: boolean }>`
	display: flex;
	align-items: center;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.25rem;
	padding: 0.25rem 0.5rem;
	cursor: pointer;
	${({ $truncate }) => ($truncate ? 'max-width: 100%; min-width: 0; overflow: hidden;' : '')}

	&:hover {
		background-color: ${({ theme }) => theme.v3.colors.gray[2]};
	}

	.icon {
		margin-right: 0.25rem;
		border-right: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
		padding-right: 0.25rem;
	}

	${({ $truncate }) =>
		$truncate
			? `.label {
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					display: block;
					max-width: 100%;
				}`
			: ''}
`;
